import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 pb-24" data-testid="privacy-policy-page">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center gap-3">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)} data-testid="back-btn">
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <h1 className="text-xl font-bold text-slate-900">Politique de confidentialité</h1>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-8">
        <article className="prose prose-slate prose-sm max-w-none space-y-6">
          <p className="text-sm text-slate-500">Dernière mise à jour : mars 2026</p>

          <p>
            La société <strong>AVIS DOM PLUS Conseil</strong>, éditrice de l'application <strong>AquaReport</strong>, s'engage à protéger la vie privée des utilisateurs de son service. La présente politique décrit les données collectées, leur finalité et les droits dont vous disposez conformément au Règlement Général sur la Protection des Données (RGPD).
          </p>

          <h2 className="text-lg font-semibold text-slate-900 mt-8">1. Données collectées</h2>
          <p>Dans le cadre de l'utilisation d'AquaReport, les données suivantes peuvent être collectées :</p>
          <ul className="list-disc pl-6 space-y-1 text-sm text-slate-700">
            <li><strong>Informations entreprise :</strong> nom de l'entreprise, adresse, email, téléphone, numéro SIRET, nom et prénom du gérant.</li>
            <li><strong>Données clients :</strong> nom, prénom, adresse, téléphone des clients figurant dans les rapports d'intervention.</li>
            <li><strong>Contenu des rapports :</strong> photos, descriptions techniques, conclusions et documents PDF générés.</li>
            <li><strong>Données de connexion :</strong> adresse email et mot de passe (chiffré) pour l'accès au compte.</li>
          </ul>

          <h2 className="text-lg font-semibold text-slate-900 mt-8">2. Finalité du traitement</h2>
          <p>Les données collectées sont utilisées exclusivement pour :</p>
          <ul className="list-disc pl-6 space-y-1 text-sm text-slate-700">
            <li>La création et la gestion des rapports de recherche de fuite.</li>
            <li>La génération et l'envoi de documents PDF aux parties concernées.</li>
            <li>La gestion des dossiers et le suivi des interventions.</li>
            <li>L'administration des comptes utilisateurs et entreprises.</li>
          </ul>

          <h2 className="text-lg font-semibold text-slate-900 mt-8">3. Conservation des données</h2>
          <p>
            Les données sont conservées uniquement dans le cadre de l'activité professionnelle de l'entreprise utilisatrice. Elles sont stockées de manière sécurisée sur une infrastructure cloud protégée. La suppression des données est possible sur simple demande adressée à notre support.
          </p>

          <h2 className="text-lg font-semibold text-slate-900 mt-8">4. Partage des données</h2>
          <ul className="list-disc pl-6 space-y-1 text-sm text-slate-700">
            <li>Aucune donnée n'est revendue à des tiers.</li>
            <li>L'accès aux données est strictement limité à l'entreprise utilisatrice et à ses techniciens autorisés.</li>
            <li>Les rapports ne sont transmis qu'aux destinataires désignés par l'utilisateur.</li>
          </ul>

          <h2 className="text-lg font-semibold text-slate-900 mt-8">5. Droits des utilisateurs</h2>
          <p>Conformément au RGPD, vous disposez des droits suivants :</p>
          <ul className="list-disc pl-6 space-y-1 text-sm text-slate-700">
            <li><strong>Droit d'accès :</strong> obtenir une copie des données vous concernant.</li>
            <li><strong>Droit de modification :</strong> corriger ou mettre à jour vos données personnelles.</li>
            <li><strong>Droit de suppression :</strong> demander l'effacement de vos données.</li>
          </ul>
          <p>Pour exercer ces droits, contactez-nous à l'adresse ci-dessous.</p>

          <h2 className="text-lg font-semibold text-slate-900 mt-8">6. Contact</h2>
          <p>
            Pour toute question relative à la protection de vos données :<br />
            <strong>Email :</strong>{" "}
            <a href="mailto:support@avidomplus.com" className="text-sky-600 hover:underline" data-testid="privacy-contact-email">
              support@avidomplus.com
            </a>
          </p>
        </article>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
